import React from "react";
import { Box, Collapse, Grid, Typography, useTheme } from "@mui/material";
import CategoryFilter from "./CategoryFilter";
import PodcastCard from "./PodcastCard";
import InexButton from "../InexButton";
import { useGetPodcastsQuery } from "../../store/api/podcasts";

const categories = [
  {
    name: "art-de-vivre",
    label: "Art de vivre",
    color: "#DE7489",
  },
  {
    name: "au-dela",
    label: "Au delà",
    color: "#2ACA9B",
  },
  {
    name: "cosmos",
    label: "Cosmos",
    color: "#6D3590",
  },
  {
    name: "fin-de-vie",
    label: "Fin de vie",
    color: "#D8A359",
  },
  {
    name: "inspiration",
    label: "Inspiration",
    color: "#F4F0A7",
  },
  {
    name: "nature",
    label: "Nature",
    color: "#58B66D",
  },
  {
    name: "perception",
    label: "Perception",
    color: "#EDCB64",
  },
  {
    name: "savoirs-ancestraux",
    label: "Savoirs ancestraux",
    color: "#F1E058",
  },
];

const PraticiansPodcasts = ({ ...props }) => {
  const theme = useTheme();

  const [filters, setFilters] = React.useState([]);
  const [seeMore, setSeeMore] = React.useState(false);
  const limitFecch = props?.limitPublic || 100;

  const { data } = useGetPodcastsQuery({ idCategorie: 0, offset: 0, limit: limitFecch });

  const podcasts = React.useMemo(() => {
    // const names = filters.map((filter) => filter.name);
    if (!data) return [];
    return data.items;
  }, [seeMore, data, filters]);

  return (
    <>
      <Box
        sx={{
          mt: 3,
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Branding Bold",
            fontWeight: "700",
            fontSize: 23,
            color: "white",
          }}
        >
          Nos podcasts{" "}
          <span
            style={{
              color: theme.palette.primary.main,
            }}
          >
            Praticiens
          </span>
        </Typography>
        {/*<CategoryFilter*/}
        {/*  filters={filters}*/}
        {/*  setFilters={setFilters}*/}
        {/*  options={categories}*/}
        {/*/>*/}
      </Box>
      <Grid
        container
        mt={5}
        spacing={5}
        columns={12}
        sx={{
          width: "100%",
        }}
      >
        {podcasts
          .filter((e, i) => i < 4)
          .map((product) => {
            return (
              <Grid
                item
                size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
                key={product.id}
                sx={{
                  width: "100%",
                }}
              >
                <PodcastCard product={product} />
              </Grid>
            );
          })}
        {podcasts.length === 0 && (
          <Grid size={{ xs: 12 }}>
            <Typography
              m={4}
              sx={{
                fontWeight: "bold",
                color: "white",
                textAlign: "center",
                fontSize: 23,
              }}
            >
              Il n'y a pas encore de podcasts dans ce thème...
            </Typography>
          </Grid>
        )}
      </Grid>
      <Collapse 
        in={seeMore}
        sx={{
          width: "100%",
        }}
      >
        <Grid
          container
          mt={5}
          spacing={5}
          columns={12}
          sx={{
            width: "100%",
          }}
        >
          {podcasts
            .filter((e, i) => i >= 4)
            .map((product) => {
              return (
                <Grid
                  item
                  size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
                  key={product.id}
                  sx={{
                    width: "100%",
                  }}
                >
                  <PodcastCard product={product} />
                </Grid>
              );
            })}
        </Grid>
      </Collapse>
      {podcasts.length > 4 && (
        <InexButton
          text={`Afficher ${seeMore ? "moins" : "plus"} de podcasts Praticien`}
          variant={"text"}
          textWithGradient={false}
          onClick={() => {
            setSeeMore(!seeMore);
          }}
          sx={{
            zIndex: 1,
            marginBottom: 2,
            marginTop: 5,
            width: "300px",
            height: "50px",
            background: (theme) => theme.palette.primary.main,
            color: "white",
            "&:hover": {
              backgroundColor: "white",
              "& > p": {
                color: (theme) => theme.palette.primary.main,
              },
            },
          }}
        />
      )}
    </>
  );
};

export default PraticiansPodcasts;
